import { Card, Checkbox } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { blue } from '../../color'
import { ACL_ACTION_TYPE } from '../../constants'

const CardWrapper = styled(Card)`
  .ant-card-head {
    background-color: ${blue};
    color: #fff;
    margin: -1px;
  }
`

const ACLActionCard = props => {
  const { actionList, title, aclStore, type, setActionListStatus } = props

  const [actionUpdateList, setActionUpdateList] = useState([])
  const [checkAll, setCheckAll] = useState(false)

  useEffect(() => {
    setActionUpdateList(
      actionList.map(item => ({
        ...item,
        status: item.status || false,
      }))
    )
  }, [actionList])

  useEffect(() => {
    if (actionUpdateList.length === 0) return
    aclStore.setAclActionUpdateList([
      ...aclStore.aclActionUpdateList.filter(
        item => item.tag !== actionUpdateList[0].tag
      ),
      ...actionUpdateList,
    ])
    setCheckAll(actionUpdateList?.every(item => item.status))
  }, [actionUpdateList])

  const conflictMap = {
    [ACL_ACTION_TYPE.them_nguoi_INCOMING]:
      ACL_ACTION_TYPE.them_nguoi_cung_phong_ban_INCOMING,
    [ACL_ACTION_TYPE.them_nguoi_cung_phong_ban_INCOMING]:
      ACL_ACTION_TYPE.them_nguoi_INCOMING,
    [ACL_ACTION_TYPE.them_nguoi_OUTGOING]:
      ACL_ACTION_TYPE.them_nguoi_cung_phong_ban_OUTGOING,
    [ACL_ACTION_TYPE.them_nguoi_cung_phong_ban_OUTGOING]:
      ACL_ACTION_TYPE.them_nguoi_OUTGOING,
  }

  const onChange = (status, code) => {
    const conflictCode = conflictMap[code]

    const newActionList = actionUpdateList.map(item => {
      if (item.code === conflictCode) {
        return { ...item, status: false } // Uncheck action xung đột
      }
      if (item.code === code) {
        return { ...item, status } // Cập nhật trạng thái cho action hiện tại
      }
      return item
    })

    setActionUpdateList(newActionList)
    setActionListStatus(prev => ({
      ...prev,
      [type]: newActionList?.every(item => item.status),
    }))
  }

  const onCheckAllChange = e => {
    const newActionList = actionUpdateList.map(item => ({
      ...item,
      status:
        item.code === ACL_ACTION_TYPE.them_nguoi_cung_phong_ban_INCOMING ||
        item.code === ACL_ACTION_TYPE.them_nguoi_cung_phong_ban_OUTGOING
          ? false
          : e.target.checked,
    }))
    setActionUpdateList(newActionList)
    setCheckAll(e.target.checked)
    setActionListStatus(prev => ({
      ...prev,
      [type]: e.target.checked,
    }))
  }

  return (
    <CardWrapper
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '8px',
            marginLeft: '1px',
          }}>
          <Checkbox checked={checkAll} onChange={onCheckAllChange} />
          <b>{title}</b>
        </div>
      }
      size={'small'}
      style={{
        width: 300,
        backgroundColor: '#F0F5FF',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px',
      }}>
      <div
        style={{
          display: 'flex',
          gap: 6,
          flexDirection: 'column',
        }}>
        {actionUpdateList.map(item => (
          <div key={item.code}>
            <Checkbox
              checked={item.status}
              onChange={e => onChange(e.target.checked, item.code)}>
              {item.name}
            </Checkbox>
          </div>
        ))}
      </div>
    </CardWrapper>
  )
}

ACLActionCard.propTypes = {}
export default inject('aclStore')(observer(ACLActionCard))
